module.exports = __webpack_public_path__ + "static/media/scissors.50937eff.png";